<template>
  <div id="dealClose">
    <a-form-model ref="ruleForm" :model="dealVO">
      <a-row class="editform" :gutter="16">
        <a-col :span="8">
          <a-form-model-item  :colon="false" class="required" :label="$t('deal.dealClose.projectStages')" prop="projectStages" :rules="[
            {required:true,message:this.$t('lease.modal.companyTip')}
          ]">
            <a-radio-group v-model="dealVO.projectStages" :options="projectStagesOptions"></a-radio-group>
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item :colon="false" class="required" prop="closeTime" :rules="[
            {required:true,message:this.$t('lease.modal.companyTip')}
          ]" :label="$t('deal.dealClose.closeTime')">
            <a-date-picker
              style="margin: -5px 0;width: 100%"
              v-model="dealVO.closeTime"
              :disabled-date="disabledDate"
              :allowClear="false"
            />
          </a-form-model-item>
        </a-col>
        <a-col :span="8"  v-if="dealVO.projectStages == 13 && dealVO.dealOriginType == 1">
          <a-form-model-item :colon="false" class="required" prop="dealLoseCauseDO.newFailReason" :rules="[
            {required:true,message:$t('keyqingxuanzeshibaiyuanying')}
          ]" :label="$t('deal.dealClose.reason')">
            <pt-cascader :cityDatas="dealLoseReason" :placeholder="$t('baseVO.selectPlaceholder')" v-model="dealVO.dealLoseCauseDO.newFailReason" />
          </a-form-model-item>
        </a-col>
	      <a-col :span="8"  v-if="dealVO.projectStages == 13 && dealVO.dealOriginType != 1">
          <a-form-model-item :colon="false" class="required" prop="dealLoseCauseDO.failReason" :rules="[
            {required:true,message:$t('keyqingxuanzeshibaiyuanying')}
          ]" :label="$t('deal.dealClose.reason')">
            <pt-dict-select dict-path="system.business_key.consultantClose" v-model="dealVO.dealLoseCauseDO.failReason"></pt-dict-select>
          </a-form-model-item>
        </a-col>
      </a-row>
      <div v-if="false">
          <div  class="close_header">
            <div class="circular"></div>
            <div>{{$t('deal.dealClose.reason')}}</div>
            <div class="required">*</div>
          </div>
      </div>
      <div  class="editform" v-if="false">

            <a-checkbox-group  v-model="dealVO.dealLoseCauseDO.failReason">
              <div style="display: flex;justify-content: flex-start;flex-wrap: wrap;padding-top: 10px;">
                <div style="margin-bottom: 10px;width: 175px" v-for="(item,index) in  dealLoseReason" :key="index">
                  <a-checkbox  :value="item.value">{{item.label}}</a-checkbox>
                </div>
              </div>

            </a-checkbox-group>
            <div class="form_label">{{$t('deal.dealClose.other')}}</div>
            <a-textarea  v-model="dealVO.dealLoseCauseDO.failRemarks"
                         :rows="3"
                         :maxLength="200"
                         :placeholder="$t('track.trackModal.remarksTip')"
            />
            <div  class="tip_message" style="height: 24px;padding-bottom: 10px;"> <span v-if="showTips">{{ $t('key14qingshuruhuozhexuanzeyuanying') }}</span></div>
      </div>
      <div  v-show="dealVO.projectStages == 13">
        <div class="close_header">
          <div class="circular"></div>
          <div>{{$t('deal.dealClose.summary')}}</div>
        </div>
      </div>
      <a-row  class="editform"  v-show="dealVO.projectStages == 13">
        <a-col :span="24">
          <a-form-model-item  :colon="false" :label="$t('deal.dealClose.summaryRisk')">
            <a-textarea  v-model="dealVO.dealLoseCauseDO.summaryRisk"
                         :rows="3"
                         :maxLength="200"
                         :placeholder="$t('track.trackModal.remarksTip')"
            />
          </a-form-model-item>
        </a-col>
        <a-col :span="24">
          <a-form-model-item  :colon="false" :label="$t('deal.dealClose.summaryReflect')">
            <a-textarea  v-model="dealVO.dealLoseCauseDO.summaryReflect"
                         :rows="3"
                         :maxLength="200"
                         :placeholder="$t('track.trackModal.remarksTip')"
            />
          </a-form-model-item>
        </a-col>


      </a-row>
      <a-row  class="editform"  v-show="dealVO.projectStages == 12">
        <a-form-model-item  :colon="false" :label="$t('deal.dealClose.closeRemarks')">
          <a-textarea  v-decorator="decorators.closeRemarks"
                       :rows="3"
                       :maxLength="200"
                       :placeholder="$t('track.trackModal.remarksTip')"
          />
        </a-form-model-item>
      </a-row>
    </a-form-model>
  </div>
</template>

<script>
  import { getDatadictChildsByPath } from '@/api/sys/datadict'
  import dealApi, {getDealCloseReason} from '@/api/mine/deal'
  import moment from 'moment'

  export default {
    name: 'dealClose',
    props: {
      dealDO:{
        type: Object,
        default: null
      },
      isCommission:{
        type:Boolean,
        required:true
      }
    },
    data() {
      return {
        showTips:false,
        selectReasons:[],
        dealLoseReason:[],
        closeType: 12,
        dealCloseForm:this.$form.createForm(this,{}),
        projectStagesOptions:[
          {label:this.$t('deal.dealDetails.projectStageTypes.12'),value:12},
          {label:this.$t('deal.dealDetails.projectStageTypes.13'),value:13},
        ],
        dealVO:{
          closeTime:moment(),
          closeRemarks:'',
          dealOriginType:'',
          id:'',
          version:'',
          dealType:'',
          projectStages:12,
          dealLoseCauseDO:{
            failReason:[],
            newFailReason:[],
            failRemarks:undefined,
            summaryRisk:undefined,
            summaryReflect:undefined,
          }
        },
        decorators:{
          dealType:[
            'dealType',{}
          ],
          projectStages:[
            'projectStages',{rules:[{required:true,message:this.$t('lease.modal.companyTip')}]}
          ],
          closeRemarks:[
            'closeRemarks',{rules:[{required:true,message:this.$t('deal.dealClose.validations.remarks')},
                {max:200,min:2,message:this.$t('deal.dealClose.validations.remarksLength')}]}
          ],
          closeTime:[
            'closeTime',{
              rules:[{required:true,message:this.$t('lease.modal.companyTip')}],
              initialValue: this.$moment()
            }
          ],
        }
      }
    },
    mounted() {
      this.dealVO.dealOriginType = this.dealDO.dealOriginType
      this.init()
    },
    methods: {
      init(){
        this.initDealLoseReasons()
      },
      disabledDate(current){
        return current && current > moment().endOf('day');
      },
      initDealLoseReasons(){
        let this_ = this
        dealApi.getDealCloseReason().then(res=>{
          this_.dealLoseReason = res.data;
        })
      },
      submit(){
        let _this = this;
        this.$refs.ruleForm.validate(err=>{
          if(err){
            if(this.dealVO.projectStages == 12  || this.dealVO.dealOriginType != 1  || (this.dealVO.dealOriginType == 1 && this.dealVO.dealLoseCauseDO.newFailReason.length > 0 ) ){
              this.showTips = false;
            }else{
              this.showTips = true;
              _this.$emit('validateFail')
              return;
            }
            //判断交易是否有结佣信息 没有结佣信息二次确认
            if(this.dealVO.projectStages == 12){
              if(this.isCommission){
                this.execSave();
              }else{
                this.$ptConfirm({
                  title: this.$t('user.modal.tipTitle'),
                  content: '该交易没有结佣记录，确定选择交易-完成吗？',
                  okText:'取消',
                  okType:'default',
                  autoFocusButton:'null',
                  cancelText:'确定',
                  onOk: () => {
                    _this.$emit('validateFail')
                  },
                  onCancel () {
                    _this.execSave();

                  }
                })
              }
            }else{
              this.execSave();
            }
          }else{
            this.$emit('validateFail')
          }
        })
      },
      execSave(){
        this.dealVO.id = this.dealDO.id
        this.dealVO.version = this.dealDO.version
        this.dealVO.dealOriginType = this.dealDO.dealOriginType
        this.dealVO.dealType = this.dealDO.dealType
        dealApi.saveDealClose(this.dealVO).then(res=>{
          if(res.code == 1){
            this.$message.success(res.message)
            this.$emit('refresh')
          }else{
            // this.$message.error(res.message)
            this.$emit('validateFail')
          }
        })
      }
    }
  }
</script>

<style lang="less" scoped>
 #dealClose{
  /deep/ .ant-form-item-no-colon:after{
    display: none;
    }
  }
  .editform{
    background: rgba(248,249,251,0.62);
    border-radius: 0 0 4px 4px;
    padding: 10px 20px;
  }
  .close_header{
    display: flex;
    align-items: center;
    font-size: 12px;
    color: #333333;
    padding: 10px 0px;
    .circular{
      width: 12px;
      height: 12px;
      background: #fabe00;
      border-radius: 50%;
      margin-right: 10px;
    }
    .required{
      color: #f5222d;
      margin-left: 5px;
    }

  }
  .tip_message{
     color: #f5222d;
   }

  .form_label{
    font-size: 12px;
    color: #999999;
    padding: 10px 0px;
  }
</style>

<style lang="less">
  #dealClose{
    .ant-checkbox-wrapper.ant-checkbox-group-item{
      display:block;
    }
  }
</style>